import { Type } from '@sinclair/typebox';
import { getChannel } from '@ayocore/platform/messaging/client';
import { LlmActivityEventSchema, type LlmActivityEvent } from '../common/types/llm-activity';
import { LlmStreamEventSchema, type LlmStreamEvent } from '../common/types/llm-stream';

/**
 * Клиентский канал активности LLM-агентов.
 */
export const llmActivityChannelClient = getChannel<unknown, LlmActivityEvent>('llm').withSchema(
  Type.Unknown(),
  LlmActivityEventSchema
);

/**
 * Клиентский канал для стрим-событий LLM.
 * Используется для получения chunks в реальном времени от LlmStreamRequest.
 */
export const llmStreamChannelClient = getChannel<unknown, LlmStreamEvent>('llm-stream').withSchema(
  Type.Unknown(),
  LlmStreamEventSchema
);
